import { showAlert } from "components/Common/commonFunctions";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import TagInputSection from "components/Modal/TagInputSection";
import StatusToggle from "components/ToggleButton/StatusToggle";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { MAX_FILE_SIZE } from "variables/constants";
import { DEFAULT_STATUS_LABELS } from "variables/constants";
import { publisherFormFields } from "variables/formFields";

const initialData = [
  {
    id: 1,
    companyName: "TechMedia Inc",
    companyAddress: "Pune",
    primaryEmail: "contact@techmedia.com",
    phone: "9834758887",
    pocFirstName: "John",
    pocLastName: "Doe",
    accountingEmail: "accounting@techmedia.com",
    gamNetworkId: "GAM-123456",
    gamAdminEmail: "admin@techmedia.com",
    productType: "Banner",
    status: "ACTIVE",
    siteNames: ["techmedia.com", "news.techmedia.com"],
    bundleIds: ["com.techmedia.app", "com.techmedia.news"],
  },
  {
    id: 2,
    companyName: "Digital Publishers Co",
    companyAddress: "Mumbai",
    primaryEmail: "info@digitalpub.com",
    phone: "9123456789",
    pocFirstName: "Jane",
    pocLastName: "Smith",
    accountingEmail: "accounts@digitalpub.com",
    gamNetworkId: "GAM-223344",
    gamAdminEmail: "gam@digitalpub.com",
    productType: "Instream",
    status: "INACTIVE",
    siteNames: ["digitalpub.com", "digitalnews.com"],
    bundleIds: ["com.digitalpub.main"],
  },
  {
    id: 3,
    companyName: "Global Ads Network",
    companyAddress: "Delhi",
    primaryEmail: "support@globalads.com",
    phone: "9988776655",
    pocFirstName: "Mike",
    pocLastName: "Johnson",
    accountingEmail: "finance@globalads.com",
    gamNetworkId: "GAM-334455",
    gamAdminEmail: "admin@globalads.com",
    productType: "Interstitial",
    status: "INACTIVE",
    siteNames: ["globalads.com"],
    bundleIds: ["com.globalads.app"],
  },
  {
    id: 4,
    companyName: "NextGen Publishing",
    companyAddress: "Bangalore",
    primaryEmail: "hello@nextgenpub.com",
    phone: "9876543210",
    pocFirstName: "Emily",
    pocLastName: "Davis",
    accountingEmail: "billing@nextgenpub.com",
    gamNetworkId: "GAM-445566",
    gamAdminEmail: "gam@nextgenpub.com",
    productType: "Rewarded",
    status: "ACTIVE",
    siteNames: ["nextgennews.com", "futurecontent.com"],
    bundleIds: ["com.nextgen.news", "com.futurecontent.app"],
  },
  {
    id: 5,
    companyName: "MediaVerse Solutions",
    companyAddress: "Hyderabad",
    primaryEmail: "contact@mediaverse.io",
    phone: "9012345678",
    pocFirstName: "Robert",
    pocLastName: "Brown",
    accountingEmail: "payments@mediaverse.io",
    gamNetworkId: "GAM-556677",
    gamAdminEmail: "admin@mediaverse.io",
    productType: "Banner",
    status: "ACTIVE",
    siteNames: ["mediaverse.io", "contenthub.io"],
    bundleIds: ["io.mediaverse.app"],
  },
  {
    id: 6,
    companyName: "Premium Publishers Ltd",
    companyAddress: "Chennai",
    primaryEmail: "support@premiumpub.com",
    phone: "9090909090",
    pocFirstName: "Sarah",
    pocLastName: "Williams",
    accountingEmail: "accounts@premiumpub.com",
    gamNetworkId: "GAM-667788",
    gamAdminEmail: "gam-admin@premiumpub.com",
    productType: "Instream",
    status: "INACTIVE",
    siteNames: ["premiumcontent.com"],
    bundleIds: ["com.premiumpub.app"],
  },
  {
    id: 7,
    companyName: "Urban Media House",
    companyAddress: "Ahmedabad",
    primaryEmail: "contact@urbanmedia.com",
    phone: "8899776655",
    pocFirstName: "David",
    pocLastName: "Miller",
    accountingEmail: "accounts@urbanmedia.com",
    gamNetworkId: "GAM-778899",
    gamAdminEmail: "admin@urbanmedia.com",
    productType: "Interstitial",
    status: "ACTIVE",
    siteNames: ["urbanmedia.com", "citynews.com"],
    bundleIds: ["com.urbanmedia.citynews"],
  },
  {
    id: 8,
    companyName: "Insight Publishing",
    companyAddress: "Kolkata",
    primaryEmail: "info@insightpub.in",
    phone: "9345678123",
    pocFirstName: "Olivia",
    pocLastName: "Taylor",
    accountingEmail: "billing@insightpub.in",
    gamNetworkId: "GAM-889900",
    gamAdminEmail: "gam@insightpub.in",
    productType: "Rewarded",
    status: "ACTIVE",
    siteNames: ["insightnews.in"],
    bundleIds: ["in.insightpub.app"],
  },
  {
    id: 9,
    companyName: "FutureScope Media",
    companyAddress: "Noida",
    primaryEmail: "support@futurescope.media",
    phone: "9988123456",
    pocFirstName: "Daniel",
    pocLastName: "Anderson",
    accountingEmail: "finance@futurescope.media",
    gamNetworkId: "GAM-990011",
    gamAdminEmail: "admin@futurescope.media",
    productType: "Banner",
    status: "INACTIVE",
    siteNames: ["futurescope.media", "techscope.media"],
    bundleIds: ["media.futurescope.tech"],
  },
  {
    id: 10,
    companyName: "Creative Buzz Network",
    companyAddress: "Jaipur",
    primaryEmail: "hello@creativebuzz.in",
    phone: "9812345670",
    pocFirstName: "Sophia",
    pocLastName: "Martinez",
    accountingEmail: "accounts@creativebuzz.in",
    gamNetworkId: "GAM-101112",
    gamAdminEmail: "gam@creativebuzz.in",
    productType: "Instream",
    status: "INACTIVE",
    siteNames: ["creativebuzz.in"],
    bundleIds: ["in.creativebuzz.app"],
  },
  {
    id: 11,
    companyName: "AlphaStream Media",
    companyAddress: "Indore",
    primaryEmail: "contact@alphastream.com",
    phone: "9712345678",
    pocFirstName: "Chris",
    pocLastName: "Wilson",
    accountingEmail: "billing@alphastream.com",
    gamNetworkId: "GAM-121314",
    gamAdminEmail: "admin@alphastream.com",
    productType: "Interstitial",
    status: "ACTIVE",
    siteNames: ["alphastream.com", "streamnews.com"],
    bundleIds: ["com.alphastream.news"],
  },
  {
    id: 12,
    companyName: "Visionary Content Group",
    companyAddress: "Surat",
    primaryEmail: "info@visionarycontent.in",
    phone: "9870012345",
    pocFirstName: "Ava",
    pocLastName: "Thomas",
    accountingEmail: "accounts@visionarycontent.in",
    gamNetworkId: "GAM-141516",
    gamAdminEmail: "gam@visionarycontent.in",
    productType: "Rewarded",
    status: "INACTIVE",
    siteNames: ["visionarycontent.in", "vcgmedia.in"],
    bundleIds: ["in.visionarycontent.app"],
  },
];

function AddPublisher() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};
  const [data, setData] = useState(initialData);
  const [selected, setSelected] = useState(null);
  const [formState, setFormState] = useState({
    values: {
      status: true,
      siteNames: [],
      bundleIds: [],
      productType: "",
    },
    errors: {},
  });

  const isEditMode = !!selected;
  const title = isEditMode ? "Edit Publisher" : "Add Publisher";
  const normalFields = publisherFormFields.filter((f) => f.type !== "toggle");
  const toggleFields = publisherFormFields.filter((f) => f.type === "toggle");
  const formData = formState.values;
  const errors = formState.errors;
  const trueLabel = DEFAULT_STATUS_LABELS.active;
  const falseLabel = DEFAULT_STATUS_LABELS.inactive;
  const siteNames = true;
  const bundleIds = true;
  const showDocumentUpload = false;

  useEffect(() => {
    if (state) {
      setSelected(state);
      setFormState({
        values: {
          ...state,
          status: state.status === "ACTIVE",
        },
        errors: {},
      });
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      values: { ...prev.values, [name]: value },
      errors: { ...prev.errors, [name]: "" },
    }));
  };

  const confirmStatus = (row) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? {
              ...item,
              status: item.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
            }
          : item,
      ),
    );
  };
  const handleStatusToggle = (row) => {
    const isActive = row.status === "ACTIVE";

    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this publisher?`,
      message: `Publisher "${row.companyName}" will be ${
        isActive ? "inactive" : "active"
      }.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => confirmStatus(row),
      onCancel: () => {},
    });
  };

  const validateForm = () => {
    const errors = {};
    publisherFormFields.forEach((f) => {
      if (f.required && !formState.values[f.name]) {
        errors[f.name] = `${f.label} is required`;
      }
    });
    setFormState((p) => ({ ...p, errors }));
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      ...formState.values,
      status: formState.values.status ? "ACTIVE" : "INACTIVE",
    };

    if (isEditMode) {
      setData((prev) =>
        prev.map((d) => (d.id === selected.id ? { ...d, ...payload } : d)),
      );
    } else {
      setData((prev) => [{ ...payload, id: Date.now() }, ...prev]);
    }

    // setModalOpen(false);
    setSelected(null);
    navigate("/admin/publishers");
  };

  const handleDocumentChange = (file) => {
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        document: { value: file, name: file.name },
      },
      errors: { ...prev.errors, document: "" },
    }));
  };

  const getDocTypeFromName = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    if (ext === "pdf") return "pdf";
    if (ext === "doc" || ext === "docx") return "doc";
    return "unknown";
  };

  const renderDocumentUpload = () => (
    <FormGroup className="d-flex flex-column align-items-start">
      <Label>
        Upload Document
        <span className="text-muted ml-1">(PDF / DOC / DOCX • Max 10 MB)</span>
      </Label>

      <div
        className="product-image-upload w-100 p-3 border rounded text-center"
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          const file = e.dataTransfer.files[0];
          if (!file) return;

          const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ];

          if (!allowedTypes.includes(file.type)) return;

          if (file.size > MAX_FILE_SIZE) {
            setFormState((prev) => ({
              ...prev,
              errors: {
                ...prev.errors,
                document: "Document size should not exceed 10 MB",
              },
            }));
            return;
          }

          handleDocumentChange(file);
        }}
      >
        {formState.values.document?.name ? (
          <div className="border rounded p-3">
            <div className="d-flex flex-column align-items-start">
              <div className="d-flex align-items-start">
                {getDocTypeFromName(formState.values.document.name) ===
                "pdf" ? (
                  <i className="fa fa-file-pdf text-danger fa-4x mb-2 ml-4" />
                ) : (
                  <i className="fa fa-file-word text-primary fa-4x mb-2 ml-4" />
                )}

                <span
                  className="text-danger pointer ml-2"
                  onClick={() =>
                    setFormState((prev) => ({
                      ...prev,
                      values: { ...prev.values, document: null },
                    }))
                  }
                >
                  <i className="fa fa-times" />
                </span>
              </div>

              <p className="mb-2">{formState.values.document.name}</p>

              {formState.values.document.mediaPath && (
                <div className="d-flex align-items-center">
                  <span
                    className="text-info pointer mr-3"
                    onClick={() =>
                      window.open(formState.values.document.mediaPath, "_blank")
                    }
                  >
                    <i className={`fa fa-eye ${isEditMode ? "" : "ml-5"}`} />
                  </span>

                  {isEditMode && (
                    <span
                      className="text-info pointer"
                      onClick={() => {
                        const a = document.createElement("a");
                        a.href = formState.values.document.mediaPath;
                        a.download = formState.values.document.name;
                        a.click();
                      }}
                    >
                      <i className="fa fa-download ml-5" />
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <i className="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
            <p className="mb-1 text-muted">Click or drag document to upload</p>
            <Label for="ioDocumentInput" className="btn btn-simple btn-sm mt-2">
              Choose Document
            </Label>
          </div>
        )}

        <Input
          type="file"
          accept=".pdf,.doc,.docx"
          className="d-none"
          id="ioDocumentInput"
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (file.size > MAX_FILE_SIZE) {
              setFormState((prev) => ({
                ...prev,
                errors: {
                  ...prev.errors,
                  document: "Document size should not exceed 10 MB",
                },
              }));
              return;
            }

            handleDocumentChange(file);
            e.target.value = "";
          }}
        />
      </div>

      {formState.errors?.document && (
        <small className="text-danger mt-1">{formState.errors.document}</small>
      )}
    </FormGroup>
  );
  return (
    <Container className="mt--6" fluid>
      {" "}
      <Card>
        <Form onSubmit={handleSubmit}>
          <CardHeader>
            <i
              className="fa-solid fa-chevron-left mr-3"
              onClick={() => navigate("/admin/publishers")}
            />
            {title}
          </CardHeader>

          <CardBody>
            {/* 🔹 NORMAL FIELDS */}
            <Row>
              {normalFields
                .filter((field) => {
                  if (isEditMode) return true;
                  if (!field.showWhen) return true;

                  const { field: dependsOn, equals } = field.showWhen;
                  const dependentValue = formData?.[dependsOn];
                  // Check here to show next fields based on condition
                  if (Array.isArray(equals)) {
                    return equals.includes(dependentValue);
                  }

                  return dependentValue === equals;
                })
                .map((field) => (
                  <Col
                    md={field.colSize || 6}
                    key={field.name}
                    className="mb-3"
                  >
                    <FormGroup>
                      {field.type !== "toggle" && (
                        <Label>
                          {field.label}
                          {field.required && (
                            <span className="text-danger ml-1">*</span>
                          )}
                        </Label>
                      )}

                      {field.type === "dropdown" ? (
                        <SearchableDropdown
                          name={field.name}
                          options={field.options}
                          value={formData[field.name] || ""}
                          placeholder={field.placeholder}
                          isSearchable={field.isSearchable}
                          onChange={(value) =>
                            handleChange({
                              target: { name: field.name, value },
                            })
                          }
                          error={errors[field.name]}
                        />
                      ) : (
                        <>
                          <Input
                            type={field.type}
                            name={field.name}
                            options={field.options}
                            value={formData[field.name] || ""}
                            placeholder={field.placeholder}
                            isSearchable={field.isSearchable}
                            onChange={(value) => {
                              handleChange({
                                target: {
                                  name: field.name,
                                  value: value?.target?.value,
                                },
                              });
                            }}
                            error={errors[field.name]}
                          />
                          {errors[field.name] && (
                            <FormFeedback>{errors[field.name]}</FormFeedback>
                          )}
                          {field.showCharCount && field.maxLength && (
                            <small className="text-muted d-block mt-1">
                              {(formData[field.name] || "").length}/
                              {field.maxLength} characters
                            </small>
                          )}
                        </>
                      )}
                    </FormGroup>
                  </Col>
                ))}
            </Row>

            {showDocumentUpload && (
              <Row>
                <Col md="12">{renderDocumentUpload()}</Col>
              </Row>
            )}

            {siteNames && (
              <Row>
                <Col md="12" className="mt-2">
                  <TagInputSection
                    label="Site Names"
                    placeholder="Enter site name and press Enter"
                    valueKey="siteNames"
                    badgeColor="info"
                    formState={formState}
                    setFormState={setFormState}
                  />
                </Col>
              </Row>
            )}

            {bundleIds && (
              <Row>
                <Col md="12" className="mt-3">
                  <TagInputSection
                    label="Bundle IDs"
                    placeholder="Enter bundle ID (e.g. com.app.name)"
                    valueKey="bundleIds"
                    badgeColor="warning"
                    formState={formState}
                    setFormState={setFormState}
                  />
                </Col>
              </Row>
            )}

            {toggleFields.length > 0 && (
              <Row>
                {toggleFields.map((field) => (
                  <Col
                    md={field.colSize || 6}
                    key={field.name}
                    className="mb-3"
                  >
                    <FormGroup>
                      <div className="d-flex flex-column mt-4">
                        <Label>{field.label}</Label>
                        <StatusToggle
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          trueLabel={trueLabel}
                          falseLabel={falseLabel}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                ))}
              </Row>
            )}
          </CardBody>

          <CardFooter className="d-flex align-items-end justify-content-end">
            <Button
              type="submit"
              className="btn-gradient-primary"
              style={{ width: "20rem" }}
            >
              Submit
            </Button>
            {/* <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button> */}
          </CardFooter>
        </Form>
      </Card>
    </Container>
  );
}

export default AddPublisher;
